import * as cookie from 'cookie';
import { parseCookies, readCookie, hasDocumentCookie } from './utils'; // We can't please Rollup and TypeScript at the same time
// Only way to make both of them work

var objectAssign = require('object-assign');

var Cookies =
/** @class */
function () {
  function Cookies(cookies) {
    this.changeListeners = [];
    this.cookies = parseCookies(cookies);
    this.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
  }

  Cookies.prototype._updateBrowserValues = function () {
    if (!this.HAS_DOCUMENT_COOKIE) {
      return;
    }

    this.cookies = cookie.parse(document.cookie);
  };

  Cookies.prototype._emitChange = function (params) {
    for (var i = 0; i < this.changeListeners.length; ++i) {
      this.changeListeners[i](params);
    }
  };

  Cookies.prototype.get = function (name, options) {
    if (options === void 0) {
      options = {};
    }

    this._updateBrowserValues();

    return readCookie(this.cookies[name], options);
  };

  Cookies.prototype.getAll = function (options) {
    if (options === void 0) {
      options = {};
    }

    this._updateBrowserValues();

    var result = {};

    for (var name_1 in this.cookies) {
      result[name_1] = readCookie(this.cookies[name_1], options);
    }

    return result;
  };

  Cookies.prototype.set = function (name, value, options) {
    var _a;

    if (typeof value === 'object') {
      value = JSON.stringify(value);
    }

    this.cookies = objectAssign({}, this.cookies, (_a = {}, _a[name] = value, _a));

    if (this.HAS_DOCUMENT_COOKIE) {
      document.cookie = cookie.serialize(name, value, options);
    }

    this._emitChange({
      name: name,
      value: value,
      options: options
    });
  };

  Cookies.prototype.remove = function (name, options) {
    var finalOptions = options = objectAssign({}, options, {
      expires: new Date(1970, 1, 1, 0, 0, 1),
      maxAge: 0
    });
    this.cookies = objectAssign({}, this.cookies);
    delete this.cookies[name];

    if (this.HAS_DOCUMENT_COOKIE) {
      document.cookie = cookie.serialize(name, '', finalOptions);
    }

    this._emitChange({
      name: name,
      value: undefined,
      options: options
    });
  };

  Cookies.prototype.addChangeListener = function (callback) {
    this.changeListeners.push(callback);
  };

  Cookies.prototype.removeChangeListener = function (callback) {
    var idx = this.changeListeners.indexOf(callback);

    if (idx >= 0) {
      this.changeListeners.splice(idx, 1);
    }
  };

  return Cookies;
}();

export default Cookies;